import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { RootDispatch, RootState } from 'storage/store';

const useFetchSystemMessage = (messageKey: string) => {
  const dispatch = useDispatch<RootDispatch>();
  const htmlContent = useSelector(
    (state: RootState) => state.application?.htmlContent
  );
  const loadMessage = async () => {
    const response = await dispatch.application.getSystemMessageByKey(
      messageKey
    );
    if (response) {
      const { data } = response;
      dispatch.application.addHtmlContent({
        ...data
      });
    }
  };
  useEffect(() => {
    loadMessage();
  }, [dispatch, messageKey]);
  const htmlMessage = htmlContent?.find(
    (item) => item.messageKey === messageKey
  );
  return { message: htmlMessage?.content };
};

export default useFetchSystemMessage;
